<h2>Thank you for using NHA!</h2>

<button type="button" (click)="login()" >Click here to Log In</button>
